export default [
    {
        path: 'exame',
        component: () => import(
            /* webpackChunkName: 'parametrizacao-exame' */
            '@/views/parametrizacao/exame/Index'
        ),
        redirect: 'exame/index',
        children: [
            {
                name: 'parametrizacao-exame-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-exame' */
                    '@/views/parametrizacao/exame/List.vue'
                ),
            },
            {
                name: 'parametrizacao-exame-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-exame' */
                    '@/views/parametrizacao/exame/Form.vue'
                ),
            },
            {
                name: 'parametrizacao-exame-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-exame' */
                    '@/views/parametrizacao/exame/Form.vue'
                ),
            },
        ],
    },
]